import { createContext } from 'react'
import { initialAuthState } from './auth-state'

function stub() {
  throw new Error('Auth Provider not initialized')
}

export const initialContext = {
  ...initialAuthState,
  getAccessToken: stub,
  login: stub,
  logout: stub,
  handleRedirectCallback: stub,
}

const AuthContext = createContext(initialContext)

export default AuthContext
